export const diagnosisTypeOptions = [
  {
    value: 0,
    label: 'Основной',
  },
  {
    value: 1,
    label: 'Осложнение',
  },
  {
    value: 2,
    label: 'Сопутствующий',
  },
];

export const diagnosisNatureOptions = [
  {
    value: 0,
    label: 'Острый',
  },
  {
    value: 1,
    label: 'Хронический',
  },
  {
    value: 2,
    label: 'Впервые выявленный',
  },
];

export const generalConditionOptions = [
  {
    value: 0,
    label: 'Удовлетворительное',
  },
  {
    value: 1,
    label: 'Средней тяжести',
  },
  {
    value: 2,
    label: 'Тяжелое',
  },
  {
    value: 3,
    label: 'Крайне тяжелое',
  },
];

export const treatmentRegimenOptions = [
  {
    value: 0,
    label: 'Амбулаторный',
  },
  {
    value: 1,
    label: 'Стационарный',
  },
  {
    value: 2,
    label: 'Дома',
  },
  {
    value: 3,
    label: 'Дневной стационар',
  },
];

// Роль подписанта СЭМД. Контракт бэка (MedicalDocuments/Sign) — строго
// DOCTOR | CHIEF, справочник НСИ здесь не используется.
export const signerRoleOptions = [
  {
    value: 'DOCTOR',
    label: 'Врач',
  },
  {
    value: 'CHIEF',
    label: 'Руководитель',
  },
];
